import {
  CreateUpdateScoreRequest,
  Score,
  ScoreFormulaValidationRequest,
  ScoreFormulaValidationResponse,
} from "types/scores";

import API from "api/client";
import { envConfig } from "config";

const { scoresAPI } = envConfig;

const createScore = (request: CreateUpdateScoreRequest): Promise<Score> =>
  API.post(`${scoresAPI}`, request).then((res) => res.data);

const getScore = (id: number, choicesIds: (string | number)[]): Promise<Score> =>
  API.get(`${scoresAPI}${id}`, { params: { choicesIds } }).then((res) => res.data);

const getScores = (): Promise<Score[]> => API.get(scoresAPI).then((res) => res.data);

const deleteScore = (id: number): Promise<void> => API.delete(`${scoresAPI}${id}`).then((res) => res.data);

const updateScore = (id: number, request: CreateUpdateScoreRequest): Promise<Score> =>
  API.put(`${scoresAPI}${id}`, request).then((res) => res.data);

const validateScoreFormula = async (
  request: ScoreFormulaValidationRequest,
): Promise<ScoreFormulaValidationResponse> => {
  const { data } = await API.post(`${scoresAPI}validate`, request);
  return data;
};

export default {
  create: createScore,
  get: getScore,
  list: getScores,
  delete: deleteScore,
  update: updateScore,
  validate: validateScoreFormula,
};
